import { EntityType } from '@frontend/common';
import { ErrorHandler } from '@frontend/error-handler';
import { IdentificationClient, MyIdentificationClient } from '@frontend/identification/api';
import { CreateIdentification, Identification, IdentificationType } from '@frontend/identification/types';
import { CommonMessage } from '@frontend/lang';
import { useAccountRepository } from '@frontend/repository';
import { ToastUtil } from '@frontend/toast-utils';
import { FormattedMessage } from 'react-intl';

import UpdateModal from '../../../../modal/update-modal/update-modal.component';

export interface ApiKeyCreateProps {
    entity_id: string;
    selfService?: boolean;
    onSubmitSuccess?: (value: Identification) => void;
}

export const ApiKeyCreate = (props: ApiKeyCreateProps) => {
    const { currentAccount } = useAccountRepository();
    return (
        <UpdateModal<Identification, CreateIdentification>
            order={['key', 'secret', 'valid_timestamp']}
            values={{
                key: undefined,
                secret: undefined,
                valid_timestamp: undefined,
                type: IdentificationType.API_KEY,
                ...(!props.selfService && { entity_id: props.entity_id, entity_type: EntityType.USER })
            }}
            fieldProps={() => new Map([['valid_timestamp', { type: 'datetime' }]])}
            onSubmit={(value) =>
                props.selfService
                    ? MyIdentificationClient.postIdentification(currentAccount, value)
                    : IdentificationClient.postIdentification(currentAccount, value)
            }
            type={EntityType.IDENTIFICATION}
            label={
                <FormattedMessage
                    id='api-key.create.title'
                    defaultMessage='Create API key'
                />
            }
            onSubmitSuccess={props.onSubmitSuccess}
            successMessageOverwrite={
                <FormattedMessage
                    id='api-key.create.success'
                    defaultMessage='API key created successfully'
                />
            }
            errorMessageOverwrite={(error) => {
                switch (error.code) {
                    case 409:
                        return ToastUtil.error(
                            CommonMessage.TOAST.PROMISE.ERROR,
                            <FormattedMessage
                                id='api-key.create.error.conflict'
                                defaultMessage='An API key with this key is already linked to a user'
                            />
                        );
                    default:
                        return ErrorHandler.handleError({ error: error, entity_type: CommonMessage.OBJECTS.IDENTIFICATION.API_KEY });
                }
            }}
        />
    );
};
